// ----------------------------------------------------------------------------
// Animations
// ----------------------------------------------------------------------------
//
// Stores all iamota animation variation for reference into individual components.
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Load Styles
// -------------------------------------

import './animations.scss';


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    function scrollAnimation() {
        // Reduce offset to trigger animation sooner
        const offset = 20; // Adjust this value to control when the animation triggers

        const visible = function(partial) {
            const element = this;
            const viewTop = window.pageYOffset || document.documentElement.scrollTop;
            const viewBottom = viewTop + window.innerHeight;
            const _top = element.offsetTop + offset;
            const _bottom = _top + element.offsetHeight;
            const compareTop = partial === true ? _bottom : _top;
            const compareBottom = partial === true ? _top : _bottom;
            return compareBottom <= viewBottom && compareTop >= viewTop;
        };

        const animatedComponent = document.querySelectorAll('.animate-in');

        // Already visible modules
        animatedComponent.forEach((el) => {
            if (visible.call(el, true)) {
                el.classList.add('already-visible');
            }
        });

        window.addEventListener('scroll', () => {
            animatedComponent.forEach((el) => {
                if (visible.call(el, true)) {
                    el.classList.add('is-animated');
                }
            });
        }, {
            capture: true,
            passive: true
        });
    }

    scrollAnimation();
});